import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { icons } from '../../../../assets/dist/svg/icons';
import { styleguideConfig } from '../../config/styleguide-config';
import { IconComponent } from '../../../core/components/icon/icon.component';
import { NgClass } from '@angular/common';

@Component({
  selector: 'app-icons',
  templateUrl: './icons.component.html',
  styleUrls: ['./icons.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [IconComponent, NgClass],
})
export class IconsComponent {
  sizes = styleguideConfig.bsSizes;

  constructor() {}

  get icons() {
    return icons.filter(icon => !icon.startsWith('shape'));
  }

  get shapes() {
    return icons.filter(icon => icon.startsWith('shape'));
  }
}
